import React, {PureComponent} from 'react';
import cn from "classnames"
import { connect } from 'react-redux'
import injectSheet, {withTheme} from 'react-jss'
import flow from 'lodash/flow'
import Card from './ArticleSummaryCard'
import {round} from '../../utils/math'
import map from 'lodash/map'
//import delay from 'lodash/delay'
import {getScreenBreakpoint} from "../../selectors";
import forEach from 'lodash/forEach'
import elementResizeDetectorMaker from "element-resize-detector";

class CardGrid extends PureComponent {

    componentWillUnmount() {
        this._unmounting = true;
        this._destroyFlikity();

        if(this.erd && this._girdContainer)
            this.erd.removeListener(this._init);
    }

    componentDidMount() {
        this.erd = elementResizeDetectorMaker({ strategy: "scroll" });
        this.erd.listenTo(this._girdContainer, this._init);

        this._init();
    }

    componentDidUpdate() {
        this._init();
    }

    _init = () => {
        if( this._unmounting ) return;

        const {breakpoint, theme, carousel=true} = this.props;

        if(!carousel) return;

        if(!breakpoint || breakpoint >= theme.breakpoints.desktop ) {
            this._destroyFlikity();
        }
        else {
            this._initFlickity(this._girdContainer);
        }
    }

    _destroyFlikity = () => {
        if (this.flkty) {
            this._clearCardHeights(this._girdContainer);
            this.flkty.destroy()
            delete this.flkty
        }
    }

    _setGirdContainer = (ref) => this._girdContainer = ref;

    _setCardHeights = (ref) => {
        forEach(ref.children[0].children[0].children, (item) => {
            item.style.height = `100%`;
        });
    }

    _clearCardHeights = (ref) => {
        forEach(ref.children[0].children[0].children, (item) => {
            item.style.height = '';
        });
    }

    _initFlickity = (ref) => {

        if(!ref) return;

        if (this.flkty && this.flkty.element !== ref) {
            this.flkty.destroy()
            delete this.flkty
        }

        this._clearCardHeights(ref);

        if (this.flkty) {
            this.flkty.resize();
            this._setCardHeights(ref);
            return;
        }

        import(/* webpackChunkName: 'flickity' */ 'flickity').then(module => {
            this.flkty = new module(ref, {
                // options
                cellAlign: 'center',
                contain: true,
                wrapAround: false,
                pageDots: false,
                prevNextButtons: false,
            });

            this._setCardHeights(ref);
            //delay(() => {if(this.flkty) this.flkty.resize()} , 500);
        });

    }

    render() {
        const {classes, items, columns=3, carousel=true, singleLine=false, showSummary=true, variation, color, cardHeadingTag} = this.props;

        var cards = items && map(items, (article, i) => {
                if(!article.title) return null;
                return <div key={i} className={cn(classes.cell, {
                    grid: !carousel,
                    [classes.hide]: singleLine && i >= columns
                })}>
                    <Card className={classes.card}
                          article={article}
                          size={columns >= 3 ? 'small' : 'medium'}
                          showArticleTime={true}
                          showSummary={showSummary}
                          variation={variation}
                          color={color}
                          headingTag={cardHeadingTag}>
                    </Card>
                </div>
            }
        );

        return <div className={cn(classes.container, {grid: !carousel})} ref={this._setGirdContainer}>{cards}</div>
    }
}

const mapStateToProps = (state) => {
    return {
        breakpoint: getScreenBreakpoint(state)
    }
}

export default flow([
    injectSheet((theme) => ({
            container: {
                '& .flickity-slider': {
                    height: '100%'
                },
                margin: [0, -8],
                '-webkit-tap-highlight-color': 'transparent',
                'tap-highlight-color': 'transparent',
                '-webkit-user-select': 'none',
                '-moz-user-select': 'none',
                '-ms-user-select': 'none',
                'user-select': 'none',
                outline: 'none',
                display: 'block',
                flexWrap: 'wrap',
                overflow: 'hidden',
                [theme.breakpoint('laptop')]: {
                    overflow: 'visible',
                    display: 'flex',
                    justifyContent: 'center',
                    padding: [0, 0],
                },
                '&.grid': {
                    display: 'flex',
                    justifyContent: 'center',
                    margin: [0, `-${theme.spacing.tiny}`],
                    [theme.breakpoint('tablet')]: {
                        margin: [0, `-${theme.spacing.small}`],
                    },
                }
            },
            cell: {
                width: '90%',
                padding: [16, 8],
                [theme.breakpoint('tablet')]: {
                    width: '48%',
                },
                [theme.breakpoint('laptop')]: {
                    width: ({columns=3}) => `${round(100/columns)}%`,
                },
                '&.grid': {
                    width: '100%',
                    [theme.breakpoint('tablet')]: {
                        width: '50%',
                        padding: theme.spacing.small,
                    },
                    [theme.breakpoint('laptop')]: {
                        width: ({columns=3}) => `${round(100/columns)}%`,
                    },
                }
            },
            card: {
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                width: '100%',

            },
            hide: {
                display: 'flex',
                [theme.breakpoint('laptop')]: {
                    display: 'none'
                }
            }
        })),
    withTheme,
    connect(mapStateToProps)
])(CardGrid);



// WEBPACK FOOTER //
// ./src/components/Card/CardGridFlikity.js